import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { invalidateTrainsCache } from "utilities/api/trainQuery";
import { useTrainDetail } from "train/useTrainDetail";
import { trainSections } from "train/trainSections";
import { SidePanelLinkedShowList } from "../SidePanelLinkedShowList";

interface TrainSidePanelDetailsProps {
  trainSidePanelData: server.dto.TrainSidePanelData
}

export const TrainSidePanelDetails = (props: TrainSidePanelDetailsProps) => {
  const {
    state,
    onValueChanged,
    onSuccessfulUpdate,
    refetchFiles,
    getUpdateTrainDetails,
  } = useTrainDetail(
    props.trainSidePanelData.train,
    props.trainSidePanelData.passengers,
    props.trainSidePanelData.files,
    () => { },
    () => { },
    () => { }
  );

  const queryClient = useQueryClient();

  const onSuccessfulUpdateSidePanel = async (key: string, value: any) => {
    await onSuccessfulUpdate(key, value);
    invalidateTrainsCache(queryClient);
  }

  const sections = trainSections(state, props.trainSidePanelData.linkedShows, refetchFiles, getUpdateTrainDetails);

  return <SidePanelDetailSectionTemplate
    isInPageEditable={props.trainSidePanelData.train.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdateSidePanel}
    fields={sections}
    additionalContent={<>
      <SidePanelLinkedShowList linkedShows={props.trainSidePanelData.linkedShows} />
    </>}
  />
}